import React, {Component, ReactElement} from 'react'
import {StyledAnchor, StyledDiv, StyledImg, StyledSpan} from '../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import NatMenuMasterRepo from '../repository/NatMenuMasterRepo'
import {NatGetMenuMasterAuthedResident} from '../repository/NatGetMenuMasterAuthedResident'
import {NatGetResidentUserAuthed} from '../../residentUser/repository/NatGetResidentUserAuthed'
import {Nullable} from '../../../../app/TypeHelpers'
import {BreakPoint, Colors, DispWidthSize, FontSize} from '../../../../styledComponents/Constants'
import {AVAILABLE_OR_NOT, HAVE_OR_NOT, LOGIN_MODE, ROLE_TYPE, VALID_OR_NOT} from '../../../../CodeMaster'
import {generateMedia} from 'styled-media-query'
import {FlexGrowContent, RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import NatLoginRepo from '../../login/repository/NatLoginRepo'
import {MenuProps} from '@mui/material/Menu'
import withStyles from '@mui/styles/withStyles'
import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import {StylesProvider} from '@mui/styles'
import equal from 'fast-deep-equal'
import EventEmitterExResident from '../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import {NatGetSmoothEAvailable} from '../../residentUser/repository/NatGetSmoothEAvailable'
import {StyledLink} from '../../../../styledComponents/residentPage/Links'
import {Messages} from '../../../../Messages'
import {NatAsyncCallFunction} from '../../../common/util/Natutil'
import NatSessionRepo from '../../session/repository/NatSessionRepo'
import MessageDialogComponent from '../../../../common/resident/MessageDialogComponent'
import {AdminUserLoginInfo} from '../../login/repository/AdminUserLoginInfo'
import {KEY_LOGIN_MODE, SessionStorageHelper} from '../../../../SessionStorageHelper'
import {
    NatAdminLoginInfoSessionStorageHelper,
} from '../../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {NatGetMenuMasterAuthedAdmin} from '../repository/NatGetMenuMasterAuthedAdmin'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons'
import {NatCreateLogoutUrl} from '../../residentUser/repository/NatCreateLogoutUrl';
import NatResidentUserRepo from '../../residentUser/repository/NatResidentUserRepo';
import {UnitOwner} from '../../../../components/generalMeeting/ResidentGeneralMeetingRepo'

import {Box, Button, ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material'
import {Location, NavigateFunction} from 'react-router-dom'

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        marginTop: '4px',
        paddingBottom: '4px',
    },
})((props: MenuProps) => (
    <Menu
        elevation={0}
        // TODO: getContentAnchorElが削除されたため一旦削除
        // getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
))

// smooth-eのメニューID
const SMOOTH_E_MENU_ID: number = 100
// すべての機能を見る
const ALL_SEE: number = 999

// グローバルメニュー　折り返し個数
const GLOBAL_WRAPPING_FOR_PC: number = 6
const GLOBAL_WRAPPING_FOR_SP: number = 5

// 総会のメニューID
const GENERAL_MEETING_ID: number = 89

// 住まいレージのメニューID
const SMILEAGE_MENU_ID: number = 43

// 管理事務報告のメニューID
const MANAGEMENT_OFFICE_REPORT_ID: number = 71

// 個人設定のメニューID
const PERSONAL_SETTING_MENU_ID: number = 44

const ROLE_ID: string = 'role'

// すてきテラスのメニューID
const SUTEKI_TERRACE_MENU_ID: number = 96

// メニューアイコンProps
interface MenuIconProps {
    menuId: number
}

// 選択中判定Props
interface Current {
    current?: string
}

// アコ―ディンProps
interface OpenOrClose {
    openFlag: boolean
}

interface MenuInfo {
    menuId: number
    menuName: string
    url: string
}

interface Props {
    navigate: NavigateFunction
    menuMasterRepo: NatMenuMasterRepo,
    menuMasterList: Nullable<NatGetMenuMasterAuthedResident>,
    unitOwnerByLoginUserRoom: Nullable<UnitOwner>
    unitOwnershipByLoginUser: Nullable<HAVE_OR_NOT>
    residentUserInfo: Nullable<NatGetResidentUserAuthed>,
    smoothEAvailable: NatGetSmoothEAvailable | null,
    changeLoginSiteToAdminAvailability: boolean
    loginRepo: NatLoginRepo,
    sessionRepo: NatSessionRepo,
    location: Location,
    mypageFlg?: boolean,
    loginedFlg: boolean
    setHamburgerMenuOpenFlag?: (hamburgerMenuOpenFlag: boolean) => void
    referrableManagementAssociationsExist: boolean
    residentUserRepo: NatResidentUserRepo
}

interface States {
    menuMasterList: NatGetMenuMasterAuthedResident | null,
    priorityGlobalMenuForPc: MenuInfo[],
    notPriorityMenuForPc: MenuInfo[],
    priorityGlobalMenuForSp: MenuInfo[],
    notPriorityGlobalMenuForSp: MenuInfo[],
    all: boolean,
    open: boolean,
    anchorEl: null | HTMLElement
    setAnchorEl: null | HTMLElement
    globalWrappingFlgForPc: boolean
    globalWrappingFlgForSp: boolean
    isLoadCompleted: boolean
    currentUrl: string
    openOperationNotAvailableToAdminDialog: boolean
    openChangeLoginSiteConfirmDialog: boolean
    openUnitOwnerConfirmationDialog: boolean
    isSutekiNetSmartPhoneApplication: boolean
}

interface ExternalProps {
    eventEmitter: EventEmitterExResident
}

class NatResidentMenuMasterComponent extends Component<Props & ExternalProps, States> {
    constructor(props: Props & ExternalProps) {
        super(props)
        this.state = {
            menuMasterList: null,
            priorityGlobalMenuForPc: [
                {
                    menuId: 0,
                    menuName: '',
                    url: '',
                },
            ],
            notPriorityMenuForPc: [
                {
                    menuId: 0,
                    menuName: '',
                    url: '',
                },
            ],
            priorityGlobalMenuForSp: [
                {
                    menuId: 0,
                    menuName: '',
                    url: '',
                },
            ],
            notPriorityGlobalMenuForSp: [
                {
                    menuId: 0,
                    menuName: '',
                    url: '',
                },
            ],
            all: false,
            open: false,
            anchorEl: null,
            setAnchorEl: null,
            globalWrappingFlgForPc: false,
            globalWrappingFlgForSp: false,
            isLoadCompleted: false,
            currentUrl: this.props.location.pathname,
            openOperationNotAvailableToAdminDialog: false,
            openChangeLoginSiteConfirmDialog: false,
            openUnitOwnerConfirmationDialog: false,
            isSutekiNetSmartPhoneApplication: false,
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.backUserSettingButtonClick = this.backUserSettingButtonClick.bind(this)
        this.menuLinkClick = this.menuLinkClick.bind(this)
        this.closeOperationNotAvailableToAdminDialog = this.closeOperationNotAvailableToAdminDialog.bind(this)
        this.handleChangeLoginSiteLinkClick = this.handleChangeLoginSiteLinkClick.bind(this)
        this.handleChangeLoginSiteCancelClick = this.handleChangeLoginSiteCancelClick.bind(this)
        this.handleChangeLoginSiteOkClick = this.handleChangeLoginSiteOkClick.bind(this)
        this.getUnitOwnerConfirmationDialogComponent = this.getUnitOwnerConfirmationDialogComponent.bind(this)
        this.handleUnitOwnerConfirmationDialogNoClick = this.handleUnitOwnerConfirmationDialogNoClick.bind(this)
        this.handleUnitOwnerConfirmationDialogYesClick = this.handleUnitOwnerConfirmationDialogYesClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const isSutekiNetSmartPhoneApplication = SessionStorageHelper.getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')
        this.setState({
            isSutekiNetSmartPhoneApplication: isSutekiNetSmartPhoneApplication === 'true',
        })
        await this.setMenuData()
    }

    async componentDidUpdate(prevProps: Props, prevState: States): Promise<void> {
        if (!equal(prevProps.menuMasterList, this.props.menuMasterList) ||
            !equal(prevProps.residentUserInfo, this.props.residentUserInfo) ||
            !equal(prevProps.smoothEAvailable, this.props.smoothEAvailable) ||
            !equal(prevProps.changeLoginSiteToAdminAvailability, this.props.changeLoginSiteToAdminAvailability) ||
            !equal(prevProps.unitOwnershipByLoginUser, this.props.unitOwnershipByLoginUser) ||
            !equal(prevProps.unitOwnerByLoginUserRoom, this.props.unitOwnerByLoginUserRoom)
        ) {
            if (this.props.loginedFlg) {
                await this.setMenuData()
            }
        }
        if (prevState.currentUrl !== this.props.location.pathname) {
            this.setState({currentUrl: this.props.location.pathname})
        }
    }

    async setMenuData(): Promise<void> {
        const menuMasterList: Nullable<NatGetMenuMasterAuthedResident> = this.props.menuMasterList
        if (menuMasterList === null ||
            (menuMasterList && menuMasterList.details === null)) {
            return
        }

        // FLPから情報取得が行えない場合、管理者として後続の処理を判定する
        const loginModeAdmin: boolean = this.isLoginModeAdmin()

        if (menuMasterList.details) {
            // メニュー項目配列のコピーを作成してpropsのデータを変更しないようにする
            const menuMasterListDetails = [...menuMasterList.details]

            // 自分が非区分所有者もしくは他に区分所有者がいるとき、総会のメニューを取り除く
            const loginUserId = SessionStorageHelper.getStringItemOrNull('userId')
            if (!loginUserId) {
                throw new Error('ユーザIDの取得に失敗しました。')
            }
            const generalMeetingMenuIndex = menuMasterListDetails
                .findIndex(menu => menu.menuId === GENERAL_MEETING_ID)
            if (generalMeetingMenuIndex !== -1) {
                if (
                    this.props.unitOwnershipByLoginUser === HAVE_OR_NOT.NOT ||
                    (this.props.unitOwnershipByLoginUser === null &&
                        this.props.unitOwnerByLoginUserRoom !== null)
                ) {
                    menuMasterListDetails.splice(generalMeetingMenuIndex, 1)
                }
            }

            // smooth-eを利用可能ならばsmooth-eのメニューを追加する
            if (this.props.smoothEAvailable !== null &&
                this.props.smoothEAvailable.details !== null &&
                this.props.smoothEAvailable.details.availability === AVAILABLE_OR_NOT.AVAILABLE.value) {
                const smoothEMenu = {
                    menuId: SMOOTH_E_MENU_ID,
                    menuName: 'smooth-e',
                    url: this.props.smoothEAvailable.details.ssoUrl,
                }
                // 個人設定メニューの位置を一番後ろにするため、個人設定メニューがある時はその前に追加する
                const personalSettingMenuIndex = menuMasterListDetails
                    .findIndex(menu => menu.menuId === PERSONAL_SETTING_MENU_ID)
                if (personalSettingMenuIndex !== -1) {
                    menuMasterListDetails.splice(personalSettingMenuIndex, 0, smoothEMenu)
                } else {
                    menuMasterListDetails.push(smoothEMenu)
                }
            }

            const managementOfficeReportMenuIndex = menuMasterListDetails
                .findIndex(menu => menu.menuId === MANAGEMENT_OFFICE_REPORT_ID)
            if (managementOfficeReportMenuIndex !== -1 && !loginModeAdmin) {
                // 公開設定をもとに管理事務報告のメニューを取り除く
                if (!this.props.referrableManagementAssociationsExist) {
                    menuMasterListDetails.splice(managementOfficeReportMenuIndex, 1)
                }
            }

            // 居住者でログインかつ長谷工ID未連携のとき、住まいレージのメニューを取り除く
            const accessControlDiv = this.props.residentUserInfo?.details?.accessControlDiv ?? ''
            if (!loginModeAdmin && accessControlDiv !== AVAILABLE_OR_NOT.AVAILABLE.value) {
                const smileageMenuIndex = menuMasterListDetails
                    .findIndex(menu => menu.menuId === SMILEAGE_MENU_ID)
                if (smileageMenuIndex !== -1) {
                    menuMasterListDetails.splice(smileageMenuIndex, 1)
                }
            }

            // PC用　優先メニュー/非優先メニュー配列を生成
            const priorityGlobalMenuForPc: MenuInfo[] = []
            const notPriorityMenuForPc: MenuInfo[] = []
            for (let i: number = 0; i < Object.keys(menuMasterListDetails).length; i++) {
                if (i >= GLOBAL_WRAPPING_FOR_PC) {
                    notPriorityMenuForPc.push({
                            menuId: menuMasterListDetails[i].menuId,
                            menuName: menuMasterListDetails[i].menuName,
                            url: menuMasterListDetails[i].url,
                        },
                    )
                } else {
                    priorityGlobalMenuForPc.push({
                            menuId: menuMasterListDetails[i].menuId,
                            menuName: menuMasterListDetails[i].menuName,
                            url: menuMasterListDetails[i].url,
                        },
                    )
                }
            }
            // SP用　優先メニュー/非優先メニュー配列を生成
            const priorityGlobalMenuForSp: MenuInfo[] = []
            const notPriorityGlobalMenuForSp: MenuInfo[] = []
            for (let i: number = 0; i < Object.keys(menuMasterListDetails).length; i++) {
                if (i >= GLOBAL_WRAPPING_FOR_SP) {
                    notPriorityGlobalMenuForSp.push({
                            menuId: menuMasterListDetails[i].menuId,
                            menuName: menuMasterListDetails[i].menuName,
                            url: menuMasterListDetails[i].url,
                        },
                    )
                } else {
                    priorityGlobalMenuForSp.push({
                            menuId: menuMasterListDetails[i].menuId,
                            menuName: menuMasterListDetails[i].menuName,
                            url: menuMasterListDetails[i].url,
                        },
                    )
                }
            }

            await this.setState({
                menuMasterList: {...menuMasterList, details: menuMasterListDetails},
                priorityGlobalMenuForPc: priorityGlobalMenuForPc,
                notPriorityMenuForPc: notPriorityMenuForPc,
                priorityGlobalMenuForSp: priorityGlobalMenuForSp,
                notPriorityGlobalMenuForSp: notPriorityGlobalMenuForSp,
                globalWrappingFlgForPc: (
                    notPriorityMenuForPc.length !== 0 ||
                    this.props.changeLoginSiteToAdminAvailability
                ),
                globalWrappingFlgForSp: (notPriorityGlobalMenuForSp.length !== 0),
                isLoadCompleted: true,
            })
        }
    }

    isLoginModeAdmin(): boolean {
        return this.props.residentUserInfo === null || this.props.residentUserInfo.details === null
    }

    createHiddenMenu(column: number, menuInfo: MenuInfo[]): MenuInfo[][] {
        return menuInfo.reduce(
            (tempArray, _, i) => (i % column ? tempArray : [...tempArray, menuInfo.slice(i, i + column)]),
            [] as MenuInfo[][],
        )
    }

    renderShortfallMenuItem(menuCount: number, column: number): Nullable<ReactElement[]> {
        const shortfall = column - menuCount
        const items: ReactElement[] = []
        for (let i = 0; i < shortfall; i++) {
            items.push(<DummyMenuBox key={i}/>)
        }
        return items
    }

    // ハンバーガーメニュー（Open）
    handleClick(): void {
        const anchorEl = document.getElementById('headerSpHamburgerMenu') as HTMLElement
        this.setState({open: true, anchorEl: anchorEl ? anchorEl : null})
        if (this.props.setHamburgerMenuOpenFlag) {
            this.props.setHamburgerMenuOpenFlag(true)
        }
        document.body.setAttribute('style', 'height: 100%; width:100%; position: fixed;')
        document.getElementsByTagName('html')[0].setAttribute('style', 'height: 100%; overflow: hidden;')
    }

    // ハンバーガーメニュー（Close）
    handleClose(): void {
        this.setState({open: false, anchorEl: null})
        if (this.props.setHamburgerMenuOpenFlag) {
            this.props.setHamburgerMenuOpenFlag(false)
        }
        document.body.removeAttribute('style')
        document.getElementsByTagName('html')[0].removeAttribute('style')
    }

    // ログアウト クリック
    async backUserSettingButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // アプリの場合はreturn
            const isSutekiNetSmartPhoneApplication = SessionStorageHelper
                .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

            if (isSutekiNetSmartPhoneApplication === 'true') {
                return;
            }
            const roleId = SessionStorageHelper.getStringItemOrNull(ROLE_ID)
            if (roleId !== null && roleId.slice(0, 1) === ROLE_TYPE.RESIDENT.value) {
                // ログアウト

                // 新G基盤ログアウト要求URL作成
                const natCreateLogoutUrl: Nullable<NatCreateLogoutUrl> =
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.createLogout.bind(
                            this.props.residentUserRepo), this.props.navigate, this.systemErrorTransition);
                if (natCreateLogoutUrl && natCreateLogoutUrl.details) {
                    // 新G基盤ログアウト要求
                    window.location.href = natCreateLogoutUrl.details;
                }
            } else {
                try {
                    // ログアウト
                    await this.props.loginRepo.postLogout()
                } finally {
                    this.props.eventEmitter.closeLoading()
                    document.body.removeAttribute('style')
                    document.getElementsByTagName('html')[0].removeAttribute('style')
                    this.props.navigate(
                        `/resident/login`,
                    )
                }
            }
        } catch (HttpError) {
            // 連携対象の会員情報が不足
            this.systemErrorTransition()
            return;
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // メニューリンク押下
    menuLinkClick(menuId: number, url: string, humbergerMenuFlag?: boolean): void {
        // ハンバーガーメニューの場合、閉じる
        if (humbergerMenuFlag) {
            this.handleClose()
        }

        if (menuId !== ALL_SEE) {
            this.setState({currentUrl: url})
        }

        // 住まいレージポイントサービスの場合
        if (SMILEAGE_MENU_ID === menuId) {
            // 管理者操作不可メッセージダイアログを表示する（ここに来るのは管理者のときのみ）
            this.setState({openOperationNotAvailableToAdminDialog: true})
        } else if (menuId === ALL_SEE) {
            // すべてを見る
            this.setState({all: !this.state.all})
        } else if (
            menuId === GENERAL_MEETING_ID &&
            SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_MODE) === LOGIN_MODE.RESIDENT.value &&
            this.props.unitOwnershipByLoginUser === null &&
            this.props.unitOwnerByLoginUserRoom === null
        ) {
            this.setState({openUnitOwnerConfirmationDialog: true})
        } else {
            // メニュー押下の場合、画面遷移
            this.props.navigate(url)
        }
    }

    closeOperationNotAvailableToAdminDialog(): void {
        this.setState({
            openOperationNotAvailableToAdminDialog: false,
        })
    }

    // 管理者操作不可メッセージダイアログ
    getOperationNotAvailableToAdminDialogComponent(): ReactElement {
        return (
            <MessageDialogComponent
                open={this.state.openOperationNotAvailableToAdminDialog}
                params={{
                    title: '確認',
                    errorLevel: Messages.ISYCR0001.errorLevel,
                    message: Messages.ISYCR0001.toString(),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.closeOperationNotAvailableToAdminDialog,
                        },
                    ],
                }}
            />
        )
    }

    handleChangeLoginSiteLinkClick(): void {
        this.setState({
            openChangeLoginSiteConfirmDialog: true,
        })
    }

    handleChangeLoginSiteCancelClick(): void {
        this.setState({
            openChangeLoginSiteConfirmDialog: false,
        })
    }

    async handleChangeLoginSiteOkClick(): Promise<void> {
        this.setState({
            openChangeLoginSiteConfirmDialog: false,
        })

        const adminUserLoginInfo: Nullable<AdminUserLoginInfo> = await NatAsyncCallFunction(
            this.props.sessionRepo.changeLoginSiteToAdmin.bind(this.props.sessionRepo),
            this.props.navigate,
        )
        if (adminUserLoginInfo === null) {
            return
        }

        SessionStorageHelper.removeAllItem()
        NatAdminLoginInfoSessionStorageHelper.setSessionStorage(adminUserLoginInfo)

        if (adminUserLoginInfo.condominiumCd) {
            NatAdminLoginInfoSessionStorageHelper.setSessionStorageForCondominiumMode(
                adminUserLoginInfo.authority,
                adminUserLoginInfo.condominiumCd,
                adminUserLoginInfo.condominiumName,
            )
        }

        const menuInfo: NatGetMenuMasterAuthedAdmin = await this.props.menuMasterRepo.getMenuMasterAuthedAdmin()
        if (!menuInfo.details || menuInfo.details.length === 0) {
            this.props.navigate(
                '/resident/error',
                {state: {message: Messages.EOPCC0042.toString('管理者様向けサービス')}},
            )
            return
        }
        const nextUrlPath = menuInfo?.details?.[0].childMenuInfo?.[0].url
        if (nextUrlPath) {
            this.props.navigate(nextUrlPath)
        }
    }

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`,
            {
                state: {
                    message: Messages.ESYCC0015.toString(),
                }
            })
    }

    // 管理者画面切り替え確認ダイアログ
    getChangeLoginSiteConfirmDialogComponent(): ReactElement {
        return (
            <MessageDialogComponent
                open={this.state.openChangeLoginSiteConfirmDialog}
                params={{
                    title: '確認',
                    errorLevel: Messages.WOPCR0003.errorLevel,
                    message: Messages.WOPCR0003.toString('素敵ネット', '素敵ネット管理用'),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleChangeLoginSiteCancelClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleChangeLoginSiteOkClick,
                        },
                    ],
                }}
            />
        )
    }

    getUnitOwnerConfirmationDialogComponent(): ReactElement {
        return <MessageDialogComponent
            open={this.state.openUnitOwnerConfirmationDialog}
            params={{
                title: '確認',
                errorLevel: Messages.WGMTR0005.errorLevel,
                message: Messages.WGMTR0005.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'いいえ',
                        buttonHandler: this.handleUnitOwnerConfirmationDialogNoClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'はい',
                        buttonHandler: this.handleUnitOwnerConfirmationDialogYesClick,
                    },
                ],
            }}
        />
    }

    handleUnitOwnerConfirmationDialogYesClick(): void {
        this.setState({openUnitOwnerConfirmationDialog: false})
        this.props.navigate(
            '/resident/general-meeting/unit-owner-confirmation-verification-method-selection',
            {
                state: {
                    rootPageUrl: '/resident/mypage'
                }
            }
        )
    }

    handleUnitOwnerConfirmationDialogNoClick(): void {
        this.setState({openUnitOwnerConfirmationDialog: false})
    }

    renderPc(): Nullable<ReactElement> {
        const hiddenMenu: MenuInfo[][] = this.createHiddenMenu(
            GLOBAL_WRAPPING_FOR_PC, this.state.notPriorityMenuForPc)

        if (this.state.menuMasterList !== null &&
            this.state.menuMasterList.details !== null) {
            return (
                <>
                    <StylesProvider injectFirst>
                        <MenuFlex>
                            {
                                this.state.priorityGlobalMenuForPc.map
                                ((menuMasterInfo, index) =>
                                    this.renderMenuItem(
                                        menuMasterInfo.menuId, menuMasterInfo.url, menuMasterInfo.menuName, index),
                                )
                            }
                            {this.state.globalWrappingFlgForPc &&
                                <MenuBox
                                    onClick={() => this.menuLinkClick(ALL_SEE, '')}>
                                    <GlobalMenuOpenClose>
                                        <IconWrapper>
                                            <div>
                                                {(this.state.all) ?
                                                    <>
                                                        <ALLTxtSpan>閉じる</ALLTxtSpan>
                                                    </> :
                                                    <>
                                                        <ALLTxtSpan>すべての</ALLTxtSpan>
                                                        <ALLTxtSpan>機能を見る</ALLTxtSpan>
                                                    </>}
                                            </div>
                                            {(this.state.all) ? <StyledExpandLessIcon/> : <StyledExpansionPanel/>}
                                        </IconWrapper>
                                    </GlobalMenuOpenClose>
                                </MenuBox>
                            }
                        </MenuFlex>
                        <OpenOrCloseArea openFlag={this.state.all}>
                            {hiddenMenu.map((hiddenMenuInfo, hiddenMenuIndex) =>
                                <MenuFlex key={hiddenMenuIndex}>
                                    {hiddenMenuInfo.map((menuMasterInfo, index) =>
                                        this.renderMenuItem(
                                            menuMasterInfo.menuId, menuMasterInfo.url, menuMasterInfo.menuName, index),
                                    )}
                                    {this.renderShortfallMenuItem(hiddenMenuInfo.length, GLOBAL_WRAPPING_FOR_PC + 1)}
                                </MenuFlex>,
                            )}
                            {this.props.changeLoginSiteToAdminAvailability &&
                                <ChangeLoginSiteLinkArea>
                                    <ResidentLink onClick={this.handleChangeLoginSiteLinkClick}>
                                        素敵ネット管理用へ
                                    </ResidentLink>
                                    管理者様向けサービスに移動します
                                </ChangeLoginSiteLinkArea>
                            }
                        </OpenOrCloseArea>
                    </StylesProvider>
                </>
            )
        } else {
            return null
        }
    }

    renderSp(): Nullable<ReactElement> {
        const hiddenMenu: MenuInfo[][] = this.createHiddenMenu(
            GLOBAL_WRAPPING_FOR_SP, this.state.notPriorityGlobalMenuForSp)

        if (this.state.menuMasterList !== null &&
            this.state.menuMasterList.details !== null) {
            return (
                <>
                    <StylesProvider injectFirst>
                        <MenuFlex>
                            {
                                this.state.priorityGlobalMenuForSp.map
                                ((menuMasterInfo, index) =>
                                    this.renderMenuItem(
                                        menuMasterInfo.menuId, menuMasterInfo.url, menuMasterInfo.menuName, index),
                                )
                            }
                        </MenuFlex>
                        <OpenOrCloseArea openFlag={this.state.all}>
                            {hiddenMenu.map((hiddenMenuInfo, hiddenMenuIndex) =>
                                <MenuFlex key={hiddenMenuIndex}>
                                    {hiddenMenuInfo.map((menuMasterInfo, index) =>
                                        this.renderMenuItem(
                                            menuMasterInfo.menuId, menuMasterInfo.url, menuMasterInfo.menuName, index),
                                    )}
                                    {this.renderShortfallMenuItem(hiddenMenuInfo.length, GLOBAL_WRAPPING_FOR_SP)}
                                </MenuFlex>,
                            )}
                        </OpenOrCloseArea>
                        {(this.state.globalWrappingFlgForSp) ?
                            <a onClick={() => this.menuLinkClick(ALL_SEE, '')}>
                                <GlobalMenuAccordionFlexItemForSp>
                                    <ResidentRowFlexContainer>
                                        {(this.state.all) ? '閉じる' : 'すべての機能を見る'}
                                        {(this.state.all) ? <StyledExpandLessIcon/> : <StyledExpansionPanel/>}
                                    </ResidentRowFlexContainer>
                                </GlobalMenuAccordionFlexItemForSp>
                            </a> : ''}
                    </StylesProvider>
                </>
            )
        } else {
            return null
        }
    }

    renderSpHamburgerMenu(): Nullable<ReactElement> {

        if (this.state.menuMasterList !== null &&
            this.state.menuMasterList.details !== null) {
            return (
                <StylesProvider injectFirst>
                    <StyledHamburgerMenuButton
                        aria-controls="customized-menu"
                        aria-haspopup="true"
                        variant="contained"
                        color="primary"
                        onClick={this.handleClick}
                    >
                        {(this.state.open) ?
                            <StyledHamburgerMenuCloseIcon/> : <StyledHamburgerMenuIcon/>}
                    </StyledHamburgerMenuButton>
                    <StyledMenu
                        id="customized-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >
                        {this.state.menuMasterList &&
                            this.state.menuMasterList.details &&
                            Object.entries(this.state.menuMasterList.details).map
                            ((menuMasterInfo, index) =>
                                <div key={index}>
                                    {this.renderHamburgerMenuItem(
                                        (Object.entries(menuMasterInfo[1])[0][1]),
                                        (Object.entries(menuMasterInfo[1])[2][1]),
                                        (Object.entries(menuMasterInfo[1])[1][1]))
                                    }
                                </div>)
                        }
                        <Box height={'16px'}/>
                        {this.props.changeLoginSiteToAdminAvailability &&
                            <MenuContent>
                                {this.state.isSutekiNetSmartPhoneApplication ?
                                    <ResidentLink href={'/admin/login-portal'} target={'_blank'}>
                                        素敵ネット管理用へ
                                    </ResidentLink>
                                    :
                                    <ResidentLink onClick={this.handleChangeLoginSiteLinkClick}>
                                        素敵ネット管理用へ
                                    </ResidentLink>
                                }
                                管理者様向けサービスに移動します
                            </MenuContent>}
                        <MenuContent>
                            <ResidentLink onClick={this.backUserSettingButtonClick}>
                                <span id={'logoutMenuBtn'}>ログアウト</span>
                            </ResidentLink>
                        </MenuContent>
                    </StyledMenu>
                </StylesProvider>
            )
        } else {
            return null
        }
    }

    // ハンバーガーメニュー（Item）
    renderHamburgerMenuItem(menuId: number, menuUrl: string, menuName: string): ReactElement {
        // 住まいレージメニューは基本的に外部リンクとなるが、ログインユーザーが管理者のときは
        // 管理者操作不可ダイアログを表示するためにメニュークリック処理を呼ぶ
        let clickHandler: (() => void) | undefined
        let externalLink: ReactElement | undefined
        if (((SMILEAGE_MENU_ID === menuId || SMOOTH_E_MENU_ID === menuId) && !this.isLoginModeAdmin())
            || SUTEKI_TERRACE_MENU_ID === menuId) {
            clickHandler = undefined
            externalLink = <ExternalLink href={menuUrl} target={'_blank'}/>
        } else {
            clickHandler = () => this.menuLinkClick(menuId, menuUrl, true)
            externalLink = undefined
        }

        // 住まいレージメニューとsmooth-eメニュー、すてきテラスメニューには外部リンクアイコンを表示する
        const showExternalLinkIcon =
            (SMILEAGE_MENU_ID === menuId) || (SMOOTH_E_MENU_ID === menuId) || (SUTEKI_TERRACE_MENU_ID === menuId)

        return (
            <StyledHamburgerMenuItem
                onClick={clickHandler}
                current={(this.state.currentUrl === menuUrl) ?
                    VALID_OR_NOT.VALID.value : VALID_OR_NOT.NOT.value}>
                <ListItemIcon>
                    <GlobalMenuIcon menuId={menuId}/>
                </ListItemIcon>
                <HamburgerMenuName>
                    <ListItemText primary={menuName}/>
                </HamburgerMenuName>
                {showExternalLinkIcon && <>
                    <FlexGrowContent/>
                    <FontAwesomeIcon icon={faExternalLinkAlt} color={Colors.AccentLight} fontSize={FontSize.Small}/>
                </>}
                {externalLink}
            </StyledHamburgerMenuItem>
        )
    }

    renderMenuItem(menuId: number, menuUrl: string, menuName: string, key: number): ReactElement {
        // 住まいレージメニューは基本的に外部リンクとなるが、ログインユーザーが管理者のときは
        // 管理者操作不可ダイアログを表示するためにメニュークリック処理を呼ぶ
        let clickHandler: (() => void) | undefined
        let externalLink: ReactElement | undefined
        if (((SMILEAGE_MENU_ID === menuId || SMOOTH_E_MENU_ID === menuId) && !this.isLoginModeAdmin())
            || SUTEKI_TERRACE_MENU_ID === menuId) {
            clickHandler = undefined
            externalLink = <ExternalLink href={menuUrl} target={'_blank'}/>
        } else {
            clickHandler = () => this.menuLinkClick(menuId, menuUrl)
            externalLink = undefined
        }

        // 住まいレージメニューとsmooth-eメニュー、すてきテラスメニューには外部リンクアイコンを表示する
        const showExternalLinkIcon =
            (SMILEAGE_MENU_ID === menuId) || (SMOOTH_E_MENU_ID === menuId) || (SUTEKI_TERRACE_MENU_ID === menuId)

        return (
            <MenuBox
                onClick={clickHandler} key={key}>
                <GlobalMenu
                    current={(this.state.currentUrl === menuUrl) ?
                        VALID_OR_NOT.VALID.value : VALID_OR_NOT.NOT.value}>
                    <IconWrapper>
                        <MenuIconImg
                            src={`/resources/images/icons/icon_${menuId}.png`}>
                        </MenuIconImg>
                        <div>
                            {menuName}
                            {showExternalLinkIcon && <>
                                &nbsp;
                                <FontAwesomeIcon icon={faExternalLinkAlt} color={Colors.AccentLight}/>
                            </>}
                        </div>
                    </IconWrapper>
                    {externalLink}
                </GlobalMenu>
            </MenuBox>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        if (this.state.menuMasterList !== null &&
            this.state.menuMasterList.details !== null) {
            // SPはマイページ表示の際もメニューを表示する
            if (this.props.mypageFlg) {
                return (
                    <>
                        <FlexSpContent>
                            <Box padding={'15px'}>
                                {this.renderSp()}
                            </Box>
                        </FlexSpContent>
                        {this.getOperationNotAvailableToAdminDialogComponent()}
                        {this.getChangeLoginSiteConfirmDialogComponent()}
                        {this.getUnitOwnerConfirmationDialogComponent()}
                    </>
                )
            } else {
                return (
                    <>
                        <FlexSpContent>
                            {this.renderSpHamburgerMenu()}
                        </FlexSpContent>
                        <FlexPcContent>
                            {this.renderPc()}
                        </FlexPcContent>
                        {this.getOperationNotAvailableToAdminDialogComponent()}
                        {this.getChangeLoginSiteConfirmDialogComponent()}
                        {this.getUnitOwnerConfirmationDialogComponent()}
                    </>
                )
            }
        }
        return null
    }
}

export default NatResidentMenuMasterComponent

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

// PC表示/SP非表示
const FlexPcContent: StyledDiv = styled.div`
  display: block;

  ${breakPoint.lessThan('sp')`
    display: none;
  `}
`

// PC非表示/SP表示
const FlexSpContent: StyledDiv = styled.div`
  display: none;

  ${breakPoint.lessThan('sp')`
    display: block;
  `}
`

const MenuFlex: StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  height: 100%;
  min-height: 80px;
  width: 100%;
  max-width: ${DispWidthSize.MaxWidth};
  margin: 0 auto 0 auto;
  background-color: ${Colors.Surface};
  font-size: ${FontSize.Small};
  z-index: 1;
  flex-wrap: nowrap;
  color: ${Colors.Primary};
`

const MenuBox: StyledDiv = styled.div`
  display: flex;
  flex-grow: 1;
  padding: 5px;
  text-align: center;
  width: 100%;

  &:last-child > div {
    &::before {
      content: none;
    }
  }
`

const ExternalLink: StyledAnchor = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const GlobalMenu = styled.div<Current>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  background-color: ${(props: Current) =>
          (props.current && props.current === VALID_OR_NOT.VALID.value) ?
                  `${Colors.PrimaryComplete}` : `${Colors.Surface}`};
  color: ${(props: Current) =>
          (props.current && props.current === VALID_OR_NOT.VALID.value) ?
                  `${Colors.Surface}` : `${Colors.Primary}`};
  cursor: pointer;
  justify-content: flex-start;
  position: relative;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    left: 99%;
    top: 1em;
    display: inline-block;
    width: 1.25px;
    height: 3.5em;
    -webkit-transform: translate(-50%);
    transform: translateX(-50%);
    background-color: ${Colors.AccentLight};
    margin-left: 8px;
  }

  &:hover {
    background-color: ${Colors.PrimaryComplete};
    color: ${Colors.Surface};

    div > svg {
      fill: ${Colors.Surface};
    }
  }
`

const GlobalMenuOpenClose: StyledDiv = styled(GlobalMenu)`
  &::before {
    content: none;
  }
`

const IconWrapper: StyledDiv = styled.div`
  min-height: 0;
  max-width: 100%;
`

const MenuIconImg: StyledImg = styled.img`
  height: 36px;
  width: 36px;
`

const OpenOrCloseArea = styled.div<OpenOrClose>`
  display: ${props => props.openFlag ? 'flex' : 'none'};
  height: ${props => props.openFlag ? '100%' : '0'};
  opacity: ${props => props.openFlag ? '1' : '0'};
  transition: ${props => props.openFlag ? '0.1s' : '0s'};
  visibility: ${props => props.openFlag ? 'visibility' : 'hidden'};
  flex-direction: column;
  max-width: ${DispWidthSize.MaxWidth};
  margin: 0 auto 0 auto;
  background-color: ${Colors.Surface};
`

const ChangeLoginSiteLinkArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 11px;
  font-size: ${FontSize.Small};
`

const ResidentLink = styled(StyledLink)`
  width: fit-content;
  font-size: ${FontSize.Middle};
  color: ${Colors.Primary};
`

const DummyMenuBox = styled(MenuBox)`
  visibility: hidden;
`

// 居住者メニューItem(Sp)（アコーディオン）
const GlobalMenuAccordionFlexItemForSp: StyledDiv = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  flex-direction: column;
  position: relative;
  background: ${Colors.Surface};
  color: ${Colors.Primary};
  height: 50px;
  width: 100%;
  text-align: center;
  border-top: 1px solid ${Colors.AccentLight};
  font-size: ${FontSize.Small};

`


// グローバルメニューアイコン
const GlobalMenuIcon = styled.div<MenuIconProps>`
  padding: 20px;
  background-repeat: no-repeat;
  margin: 5px;
  background-position: left;
  background-size: 32px;
  background-image: url(/resources/images/icons/icon_${(props: MenuIconProps) => props.menuId}.png);
`

// グローバルメニューオープンアイコン（アコーディオン）
const StyledExpansionPanel = styled(ExpandMoreIcon)`
  width: 30px;
  height: 30px;
  fill: ${Colors.Primary};
`
// グローバルメニュークローズアイコン（アコーディオン）
const StyledExpandLessIcon = styled(ExpandLessIcon)`
  width: 30px;
  height: 30px;
  fill: ${Colors.Primary};
`

const ResidentRowFlexContainer = styled(RowFlexContainer)`
  position: relative;
  justify-content: center;
`

// ハンバーガーメニュー（Button）
const StyledHamburgerMenuButton = styled(Button)`
  &.MuiButton-containedPrimary {
    background-color: ${Colors.Primary};
  }

  &.MuiButton-contained {
    box-shadow: initial;
  }

  &.MuiButton-root {
    padding: 0;
    min-width: 32px;
  }

`

// ハンバーガーメニュー（OpenIcon）
const StyledHamburgerMenuIcon = styled(MenuIcon)`
  &.MuiSvgIcon-root {
    font-size: 4.8rem;
  }
`

// ハンバーガーメニュー（CloseIcon）
const StyledHamburgerMenuCloseIcon = styled(CloseIcon)`
  &.MuiSvgIcon-root {
    font-size: 4.8rem;
  }
`

// ハンバーガーメニュー（Item）
const StyledHamburgerMenuItem = styled(MenuItem)<Current>`
  &.MuiList-padding {
    padding-right: 8px
  }

  &.MuiListItem-root {
    background-color: ${(props: Current) =>
            (props.current && props.current === VALID_OR_NOT.VALID.value) ?
                    `${Colors.PrimaryComplete}` : `${Colors.Surface}`};
    color: ${(props: Current) =>
            (props.current && props.current === VALID_OR_NOT.VALID.value) ?
                    `${Colors.Surface}` : `${Colors.Primary}`};

    border-bottom: 1px solid ${Colors.AccentLight};
  }

  .MuiTypography-body1 {
    font-size: ${FontSize.Small};
  }
`

const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${FontSize.Small};
  color: ${Colors.Body};
  padding: 8px 16px;
`

// ハンバーガーメニュー
const HamburgerMenuName: StyledSpan = styled.span`
  cursor: default;
  color: inherit;
  text-decoration: none;
`

const ALLTxtSpan: StyledSpan = styled.span`
  font-size: ${FontSize.Small};

  &::after {
    content: "\\A";
    white-space: pre;
  }
`
